





































import { Component, Vue, Prop } from 'vue-property-decorator';
import { IProjectMetadata } from '@/interfaces/report';
import { createNewAsphaltScenario } from '@/modules/design/lib/createNew/asphalt';
import { designStore } from '@/store/store';
import router from '@/router';
import { createNewConcreteScenario } from '@/modules/design/lib/createNew/concrete';
import { createNewPorousScenario } from '@/modules/design/lib/createNew/porous';
import { createNewAcOverlayScenario } from '@/modules/design/lib/createNew/acOverlay';

@Component
export default class SelectDesignScenarioType extends Vue {
  @Prop() projectMetadata!: IProjectMetadata;

  newAsphalt() {
    const scenario = createNewAsphaltScenario(this.projectMetadata);
    console.log(scenario.id, scenario.project);
    designStore.saveNewAsphaltScenario(scenario).then((savedScenario) => {
      console.log(savedScenario);
      designStore.setCurrentAsphaltScenario(savedScenario);
      if (savedScenario) {
        router.push(`asphalt/${savedScenario.id}/1`);
      }
    });
  }

  newConcrete() {
    const scenario = createNewConcreteScenario(this.projectMetadata);
    designStore.saveNewConcreteScenario(scenario).then((savedScenario) => {
      if (savedScenario) {
        router.push(`concrete/${savedScenario.id}/1`);
      }
    });
  }

  newPorous() {
    const scenario = createNewPorousScenario(this.projectMetadata);
    designStore.saveNewPorousScenario(scenario).then((savedScenario) => {
      if (savedScenario) {
        router.push(`porous/${savedScenario.id}/1`);
      }
    });
  }

  newAcOverlay() {
    const scenario = createNewAcOverlayScenario(this.projectMetadata);
    designStore.saveNewAcOverlayScenario(scenario).then((savedScenario) => {
      if (savedScenario) {
        router.push(`ac-overlay/${savedScenario.id}/1`);
      }
    });
  }
}
